import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { CookiesService } from 'app/shared/services/cookies/cookies.service';
import { Observable } from 'rxjs';

export const adminGuard: CanActivateFn = (
  next: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): Observable<boolean> | Promise<boolean> | boolean => {
  const cookieService = inject(CookiesService);
  const router: Router = inject(Router);

  const isAdmin = JSON.parse(cookieService.getCookie('userData'))?.isAdmin;
  if (!isAdmin) {
    router.navigate(['home']);
  }
  return isAdmin;
};
